/**
 * Image Validate
 *
 * Validation rules for uploaded image files and picker limits.
 */

interface ImageValidateConfig {
    maxSize?: string | number | null;
    maxFiles?: number;
}

type SizeUnit = "B" | "KB" | "MB" | "GB";

class ImageValidate {
    public static validateFile(file: File, config: ImageValidateConfig, currentImageCount: number): boolean {
        const maxSizeBytes = this.parseMaxSize(config.maxSize);

        if (file.size > maxSizeBytes) {
            console.error(`File ${file.name} is too large. Maximum size is ${config.maxSize}.`);
            return false;
        }

        if (!file.type.startsWith("image/")) {
            console.error(`File ${file.name} is not an image.`);
            return false;
        }

        if (typeof config.maxFiles === "number" && currentImageCount >= config.maxFiles) {
            console.error(`Maximum ${config.maxFiles} images allowed.`);
            return false;
        }

        return true;
    }

    public static parseMaxSize(maxSize: string | number | null | undefined): number {
        if (typeof maxSize === "number" && Number.isFinite(maxSize) && maxSize > 0) {
            return maxSize;
        }

        if (typeof maxSize !== "string") {
            return 5 * 1024 * 1024;
        }

        const units: Record<SizeUnit, number> = { B: 1, KB: 1024, MB: 1024 * 1024, GB: 1024 * 1024 * 1024 };
        const match = maxSize.trim().match(/^(\d+)\s*(B|KB|MB|GB)?$/i);

        if (!match) return 5 * 1024 * 1024;

        const value = parseInt(match[1], 10);
        const unit = ((match[2] || "B").toUpperCase() as SizeUnit) || "B";

        return value * (units[unit] || units.B);
    }
}

export { ImageValidate };
